export const CashierStatus = Object.freeze({
  open: 'open',
  closed: 'closed'
})

export const CashierTypes = Object.freeze({
  operator: 'operator',
  supervisor: 'supervisor'
})
